import { AreaOption } from 'src/app/model/area-option.model';

export class AreaLocation {
  area: string;
  field: string;
  field_sector: string;
  postcode?: string;
  areaOption?: AreaOption;
}
